"use strict";

require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _css2 = _interopRequireDefault(require("@emotion/css"));

var _react = _interopRequireDefault(require("react"));

var _Flex = _interopRequireDefault(require("../../Flex"));

var _SeparatorsContainer = _interopRequireDefault(require("../../SeparatorsContainer"));

var _useTheme2 = _interopRequireDefault(require("../../styles/useTheme"));

var _Text = _interopRequireDefault(require("../../Text"));

var _useTranslation = _interopRequireDefault(require("../TranslationProvider/useTranslation"));

var _ContractType = _interopRequireDefault(require("./ContractType"));

var _Status = _interopRequireDefault(require("./Status"));

var _core = require("@emotion/core");

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"].signature : function (a) {
  return a;
};

var Contract = function Contract(props) {
  var jobStatus = props.jobStatus;
  var t = (0, _useTranslation["default"])();

  var _useTheme = (0, _useTheme2["default"])(),
      spacing = _useTheme.spacing;

  return (0, _core.jsx)(_Flex["default"], {
    flexDirection: "column",
    padding: 4,
    width: "100%"
  }, (0, _core.jsx)(_Text["default"], {
    as: "h2",
    variant: "headline3",
    gutter: 1
  }, t('contract')), (0, _core.jsx)(_SeparatorsContainer["default"], {
    css: /*#__PURE__*/(0, _css2["default"])({
      margin: spacing(0, -4)
    }, ";label:Contract;" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9SZXNwb25zaXZlSm9iQ2FyZC9Db250cmFjdC9pbmRleC50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBd0IyQiIsImZpbGUiOiIuLi8uLi8uLi9zcmMvUmVzcG9uc2l2ZUpvYkNhcmQvQ29udHJhY3QvaW5kZXgudHN4Iiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IFJlYWN0LCB7IEZ1bmN0aW9uQ29tcG9uZW50IH0gZnJvbSAncmVhY3QnO1xuXG5pbXBvcnQgRmxleCwgeyBGbGV4UHJvcHMgfSBmcm9tICcuLi8uLi9GbGV4JztcbmltcG9ydCBTZXBhcmF0b3JzQ29udGFpbmVyIGZyb20gJy4uLy4uL1NlcGFyYXRvcnNDb250YWluZXInO1xuaW1wb3J0IHVzZVRoZW1lIGZyb20gJy4uLy4uL3N0eWxlcy91c2VUaGVtZSc7XG5pbXBvcnQgVGV4dCBmcm9tICcuLi8uLi9UZXh0JztcbmltcG9ydCB1c2VUcmFuc2xhdGlvbiBmcm9tICcuLi9UcmFuc2xhdGlvblByb3ZpZGVyL3VzZVRyYW5zbGF0aW9uJztcbmltcG9ydCBDb250cmFjdFR5cGUgZnJvbSAnLi9Db250cmFjdFR5cGUnO1xuaW1wb3J0IFN0YXR1cyBmcm9tICcuL1N0YXR1cyc7XG5cbmV4cG9ydCBpbnRlcmZhY2UgQ29udHJhdFByb3BzIGV4dGVuZHMgRmxleFByb3BzPCdkaXYnPiB7XG4gIGpvYlN0YXR1cz86IHN0cmluZztcbn1cblxuY29uc3QgQ29udHJhY3Q6IEZ1bmN0aW9uQ29tcG9uZW50PENvbnRyYXRQcm9wcz4gPSAocHJvcHMpID0+IHtcbiAgY29uc3QgeyBqb2JTdGF0dXMgfSA9IHByb3BzO1xuICBjb25zdCB0ID0gdXNlVHJhbnNsYXRpb24oKTtcbiAgY29uc3QgeyBzcGFjaW5nIH0gPSB1c2VUaGVtZSgpO1xuXG4gIHJldHVybiAoXG4gICAgPEZsZXggZmxleERpcmVjdGlvbj1cImNvbHVtblwiIHBhZGRpbmc9ezR9IHdpZHRoPVwiMTAwJVwiPlxuICAgICAgPFRleHQgYXM9XCJoMlwiIHZhcmlhbnQ9XCJoZWFkbGluZTNcIiBndXR0ZXI9ezF9PlxuICAgICAgICB7dCgnY29udHJhY3QnKX1cbiAgICAgIDwvVGV4dD5cbiAgICAgIDxTZXBhcmF0b3JzQ29udGFpbmVyIGNzcz17eyBtYXJnaW46IHNwYWNpbmcoMCwgLTQpIH19PlxuICAgICAgICA8Q29udHJhY3RUeXBlIC8+XG4gICAgICAgIDxTdGF0dXMgam9iU3RhdHVzPXtqb2JTdGF0dXN9IC8+XG4gICAgICA8L1NlcGFyYXRvcnNDb250YWluZXI+XG4gICAgPC9GbGV4PlxuICApO1xufTtcblxuZXhwb3J0IGRlZmF1bHQgQ29udHJhY3Q7XG4iXX0= */"))
  }, (0, _core.jsx)(_ContractType["default"], null), (0, _core.jsx)(_Status["default"], {
    jobStatus: jobStatus
  })));
};

__signature__(Contract, "useTranslation{t}\nuseTheme{{ spacing }}", function () {
  return [_useTranslation["default"], _useTheme2["default"]];
});

var _default = Contract;
var _default2 = _default;
exports["default"] = _default2;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"] : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(Contract, "Contract", "/builds/bA1zbJom/0/gojob/ui-bits/src/ResponsiveJobCard/Contract/index.tsx");
  reactHotLoader.register(_default, "default", "/builds/bA1zbJom/0/gojob/ui-bits/src/ResponsiveJobCard/Contract/index.tsx");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();